<template>

	<div>
		<div class="col-md-4 pt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail&&(viewToggle||!clickToggle)}">
			<div class="right_list_content" style="background:#fff;">
				<div id="right_content_title_information" class="pl-3 report_year">
					<div style="color: #208EFF;">
						<i class="fa fa-file-text fa-lg mr-2"></i>{{getzines.name}}
					</div>

					<div class="d-flex flex-wrap float-right">
						<div class="text-muted flex-fill">
							<div class="dropdown report_year_drop">
								<!--<li class="dropdown-toggle" data-toggle="dropdown">-->
									<span class="dropdown-toggle" data-toggle="dropdown">{{year}}</span>
								<!--</li>-->
								<div class="dropdown-menu nano statenano" style="height: auto;">

									<div class="nano-content" style="position:initial">

										 <a class="dropdown-item" v-for="(value, key) in years" @click="filterYear(value)" href="javascript:">{{value}}</a>
										<!--<a class="dropdown-item"  href="javascript:;">2018</a>-->

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row nano p-0 m-0 one_title_nano_middle" id="CountryReport">
					<div class="nano-content">
						<div style="padding: 0px 20px;">
							<div class="col-md-12" style="padding: 30px 0px;">
								<img v-if="getzines.logo" :src="getzines.logo" class="col-md-5 offset-md-4 p-0 img-thumbnail p-1" style="width: auto;display: block;margin: 0 auto;">
							</div>
							<div style="padding-bottom: 30px;">
								<h4 class="periodical_synopsis">Introduction</h4>
								<div class="periodical_synopsi" v-if="getzines.example != null" @click="getIssueDetail(getzines.example)">
									<img src="../../../assets/images/silkRoadBase/book.png" alt="" />Sample issue</div>
								<p class="periodical_content">
									{{getzines.memo}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}">
			<div class="right_content_previous sm_no_hide" :class="{'cur':!viewToggle}">
                <div id="consult_left_content" class="pl-3" v-if="!viewToggle">
                    <span class="myBtn" @click='goback()'>Back</span>
                </div>
				<div class="report_title">
					<div>{{getzines.name}}</div>
					<!--<div class="input_box">
						<input type="text" v-model="searchName" class="form-control pl-4" placeholder="Input country name" >
							<i class="fa fa-search fa-lg search_icon text-muted" @click="searchname()"></i>
					</div>-->
				</div>

				<!--<div class="report_main">

					<span v-for="(value, key) in getissues" class="report_main_item" @click="selectedCountry(key)" :class="{'itemActive':key == selectedKey}">{{key}}</span>
				</div>-->
				<div class="row nano p-0 m-0 one_title_nano" style="margin-top: 30px !important;" v-show="getissues[selectedKey]">
					<div class="nano-content" id="home_right_list">
						<ul class="list-unstyled report_ul" style="padding-bottom: 100px;">
							<li v-for="issue in getissues[selectedKey]" @click="getIssueDetail(issue.eid)" class="col-md-4 col-lg-3 col-xs-2" style="position: relative;">
								<span class="" style="position: relative;cursor: pointer;border-radius: .3rem;">
									<img v-if="issue.image != ''" class="img-thumbnail" :src="issue.image" style="margin-bottom: 0;">
									<span class="free_back" v-if="issue.is_free">Free</span>
									<span class="dredge_back" v-if="issue.is_open"></span>
								</span>
								<div class="report-title" style="margin-top:10px;width: 143px">
									<h5>{{issue.title}}</h5>
								</div>
							</li>
						</ul>
					</div>
				</div>

				<div  v-show="!getissues[selectedKey]" class="nodata text-center" style="height: 81.5vh;">
					<img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100"  alt="">
					<p class="text-center p-2">loading</p>
                 </div>


			</div>


		</div>
	</div>
</template>
<script>
	export default({
		name: 'countryreport',
		data: function() {
			return {
				getissues: [],
				getzines: [],
				id: this.$route.params.id,
				year: this.$route.params.year,
				searchName: '',  //搜索国家,
                selectedKey : '',
                years:[],
                viewToggle:true,
                specail:false, //特殊处理 小于544px
                clickToggle:true
			}
		},
		created: function() {
			var self = this;
            this.viewToggle=this.IsPC();
            if(this.IsPC()&&(document.body.clientWidth<=700)){
                this.specail=true
            }else{
                this.specail=false
            }
			this.$axios.post('/api/pc/getzine', {
				id: self.id
			}).then(data => {
				var getzines = data.data.data;
				self.getzines = getzines;
			})
            this.$axios.post('/api/pc/getreportcountryyear', {
                id: self.id
            }).then(data => {
                if (data.data.state) {
                    $.each(data.data.data, function(index, value){
						if(self.years.indexOf(value.year)=='-1'){
							self.years.push(value.year);
						}
                    })
                }
            })

            this.getCountryReport();

		},

		mounted() {
            document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
			this.load()
            this.getZine()
		},
		methods: {
            goback(){
                this.clickToggle=!this.clickToggle;
            },
            // 选择年份
            filterYear (year) {
                this.year = year;
                this.getCountryReport();
            },
            // 选择国家的父级
            selectedCountry (key) {
                this.selectedKey = key;
            },
            // 获取所有的国家一级国家的父级
		    getCountryReport() {
                this.$axios.post('/api/pc/getreportcountry', {
                    id: this.id,
                    year:this.year,
                    country:this.searchName
                }).then(data => {
                    if (data.data.state) {
                        // this.clickToggle=false;
                        this.getissues = data.data.data;
                        if (this.getissues) {
                            this.selectedKey = Object.keys(this.getissues)[0];
                        }
                    }

                })
            },
			//国家搜索
			searchname() {
				this.getCountryReport();
			},
			handleScroll() {
				var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_right_list').scrollHeight; // 总高度
				if((all - 20) < (top + client)) {
					this.page++;
					if(this.page > this.total_page) {
						return;
					}
					let that = this;
					this.$axios.post('/api/pc/getissue', {
						id: that.id,
						current_page: that.page,
						page_size: that.page_size
					}).then(data => {
						var getissues = data.data.data.data;
						that.getissues = that.getissues.concat(getissues);
					})
				}
			},
            getIssueDetail : function(eid) {
				this.$router.push({path:'/countryreport/'+this.id+'/'+this.year+'/'+eid});
            },
            getZine :function() {
                this.$axios.post('/api/pc/getzine', {id:this.id}).then(data => {
                    var getzines=data.data.data;
                    this.getzines=getzines;
                })

            },
            getYears :function() {
                var self = this;
                self.years = [];
                self.$axios.post('/api/pc/getreportcountryyear', {
                    id: self.id
                }).then(data => {
                    if (data.data.state) {
                        $.each(data.data.data, function(index, value){
                            if(self.years.indexOf(value.year)=='-1'){
                                self.years.push(value.year);
                            }
                        })
                    }
                })

            },
        },
        computed: {
            isFollow () {
                return this.$store.state.screenWidth;
            }
        },
        watch: {
            $route(){
                this.id = this.$route.params.id;
                this.year = this.$route.params.year;
            },
            id() {
                this.getZine();
                this.getYears();
                this.getCountryReport();
            },
            isFollow (val) {
                if (!this.timer) {
                    //this.screenWidths = val;
                    this.timer = true;
                    let that = this;
                    setTimeout(function () {
                        if(that.IsPC()&&(val<=700)){
                            that.specail=true
                        }else{
                            that.specail=false
                        }
                        that.timer = false
                    }, 300)
                }

            }
        }
	})
</script>
<style scoped>
    .myBtn{
        width:60px;
        height:30px;
        display:block;
        position:absolute;
        top:20px;
        right:20px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    .myBtn:hover{
        cursor:pointer;
    }
    .right_content_previous.cur{
        box-shadow: none;
    }
	.periodical_synopsis,.periodical_synopsi{
		display:inline-block
	}
	.periodical_synopsi{
		float:right;
		text-align:center;
		padding:6px 14px;
		height:32px;
		background:rgba(32,142,255,1);
		border-radius:18px;

		font-size:14px;
		font-family:PingFangSC-Medium;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:23px;
	}
	.periodical_synopsi:hover{
		cursor:pointer;
	}
	.periodical_synopsi img{
		width:13px;
		height:16px;
		margin-right:5px;
	}
</style>
